import { render } from "./transfer.vue?vue&type=template&id=66308092&scoped=true"
import script from "./transfer.vue?vue&type=script&lang=js"
export * from "./transfer.vue?vue&type=script&lang=js"

import "./transfer.vue?vue&type=style&index=0&id=66308092&lang=scss&scoped=true"
import "./transfer.vue?vue&type=style&index=1&id=66308092&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66308092"]])

export default __exports__